/**
 * Vesper Event Seeder Service (Shared)
 *
 * Purpose: Frontend API client for the event seeder endpoints.
 * Used by the MapScreen seeder panel (web-next).
 */

import apiClient from './api.client';
import { API } from '../constants/api';
import type {
  EventSourceSearchParams,
  ExternalEventResult,
  SeederCreateResult,
} from '../types/public_event.types';

export interface SearchSourceStatus {
  name: string;
  ok: boolean;
  count: number;
  error?: string;
}

export async function searchEvents(
  params: EventSourceSearchParams,
): Promise<{ results: ExternalEventResult[]; sources: SearchSourceStatus[] }> {
  const res = await apiClient.post<{ data: { results: ExternalEventResult[]; sources: SearchSourceStatus[] } }>(
    API.SEEDER_SEARCH,
    params,
  );
  return res.data.data;
}

export async function createSeededEvents(
  events: ExternalEventResult[],
): Promise<SeederCreateResult> {
  const res = await apiClient.post<{ data: SeederCreateResult }>(
    API.SEEDER_CREATE,
    { events },
  );
  return res.data.data;
}
